import { secondsToDuration } from '../../utils/secondsToDuration.js'
import messages from './messages.js'

export const formatDuration = (intl, durationSeconds) => {
  const duration = secondsToDuration(durationSeconds ?? 0)
  return intl.formatMessage(duration.hrs ? messages.durationShort : messages.durationMins, duration)
}
